<template>
  <div class="SituationGallery" @wheel="$event.preventDefault(); slide($event.deltaY)">

    <!-- Scrolll-Arrow Left -->
    <transition name="fade">
      <md-button v-show="arrowLeftVisible" v-on:click="slide(-100,17,700)" class="md-icon-button sg-arrow">
        <ArrowLeft/>
      </md-button>
    </transition>

    <!-- SituationGallery Items/Situations -->
    <div class="sg-items">
      <div class="sg-item" v-for="s in sortedSituations" :key="s.id" @click="changeSituation(s);" :class="{'sg-item-highlight': currentSituationID == s.id}">
        <div class="sg-item-badge" v-if="enableCommunication" v-show="numberOfUsers(s.id) > 0 && enableCommunication">{{numberOfUsers(s.id)}}</div>
        <img class="sg-item-thumbnail" :src="publicPath+'/media/'+panoramaTour.getName()+'/'+s.name.trim()+'.jpg'" alt=""/>
        <span class="sg-item-name">{{s.name}}</span>
      </div>
    </div>

    <!-- Scrolll-Arrow Right -->
    <transition name="fade">
      <md-button v-show="arrowRightVisible" v-on:click="slide(100,17,700)" class="md-icon-button sg-arrow" style="right: 0;">
        <ArrowRight/>
      </md-button>
    </transition>

  </div>
</template>

<style scoped>
.SituationGallery{
  width: 100%;
  position: relative;
  z-index: 1;
  white-space: nowrap;
  background: rgba(49, 49, 49, 0.9);
  overflow: hidden;
}
.sg-items{
  overflow: auto;
  position: relative;
  text-align: center;
}
.sg-item{
  display: inline-block;
  margin: 14px;
  position: relative;
  transition: .1s border-color;
  cursor: pointer;
  border: 6px solid transparent;
}
.sg-item:hover{
  border-color: var(--primaryColor);
}
.sg-item-highlight{
  border-color:var(--secondaryColor);
}
.sg-item-thumbnail{
  width: 290px;
  height: 170px;
}
.sg-item-name{
  position: absolute;
  z-index: 1;
  bottom: 0;
  width: 100%;
  text-align: center;
  left: 0;
  background: rgba(8, 8, 8, 0.9);
  color: white;
  padding: 9px;
  font-size: 15px;
}
.sg-item-highlight .sg-item-badge{
  background: var(--secondaryColor);
}
.sg-item:hover .sg-item-badge{
  background: var(--primaryColor);
}
.sg-item-badge{
  position: absolute;
  z-index: 2;
  font-size: 18px;
  left: -10px;
  bottom: -10px;
  height: 30px;
  width: 30px;
  background: var(--primaryColor);
  border-radius: 50%;
  text-align: center;
  color: rgb(231, 231, 231);
  line-height: 30px;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.514));
}
.sg-arrow{
  position: absolute; 
  z-index: 2;
  display: flex;
  top: 35%;
  height: 70px !important;
  width: 70px !important;
  border-radius: 50% !important;
  padding: 0 !important;
  background-color: rgb(48, 47, 47) !important;
  transition: opacity .5s ease, background-color .4s ease, transform .4s ease;
  filter: none !important;
  margin-left: 7px !important;
  margin-right: 7px !important;
}
.sg-arrow:hover{
  background-color: var(--primaryColor) !important;
  transform: scale(1.1);
}

/* Scrollbar CSS */
::-webkit-scrollbar{
  height: 13px;
}
::-webkit-scrollbar-track{
  background: rgb(49, 49, 49);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb{
  border-radius:10px;
  border: 1px solid rgb(27, 27, 27);
  background: rgb(111,111,111);
}

/*MOBILE*/
@media (max-device-width: 1200px){
	.sg-item-thumbnail {
    width: 180px;
    height: 120px;
  }
  .sg-item-name{
    padding: 5px;
  }
  .sg-arrow{
    display: none;
  }
}
</style>

<script>
import {mapGetters,mapMutations} from 'vuex';
import ArrowLeft from 'vue-material-design-icons/ArrowLeft.vue'
import ArrowRight from 'vue-material-design-icons/ArrowRight.vue'

export default {
  inject: ['toggleGallery'],
  components: {
    ArrowLeft, ArrowRight,
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    arrowLeftVisible: false,
    arrowRightVisible: false,
    situationOrder : ["Start", "Reception", "Meeting Room Hamburg", "Meeting Room Freudenberg", "Show Room Mixing Group", "Convex", "Convex + Tandem Mixer", 
    "Tandem Mixer - Bottom Machine", "Tandem Mixer - Top Machine", "HF Mixing Group - Technical Center", "Show Room Tire Building", "Show Room Curing Presses", 
    "Curemaster - Truck Press", "PCR", "PCI", "PCR 2", "PCR 3"],
  }),
  computed: {
    ...mapGetters(['situations','panoramaTour','users','currentSituationID','enableCommunication','panoramaTour']),
    sortedSituations(){
      if(this.panoramaTour){
        let sortedSituations = [];
        this.situationOrder.forEach(e1 => {
          this.situations.forEach(e2 => {
              if(e1 == e2.getName().trim()){
                sortedSituations.push(e2);
                return;
              }
          });
        });
        return sortedSituations;
      }
    }
  },
  watch:{
    situations: function(){
     setTimeout(() => {
        this.checkArrowVisibility();
      }, 1000);
    }
  },
  methods:{
    ...mapMutations(["handleGotoSituationTransition"]),

    // Changes situation and toggles SituationGallery
    changeSituation (situation) {
      this.handleGotoSituationTransition({situationID: situation.id});
      this.toggleGallery();
    },

    // Returns numbers of users in current situation
    numberOfUsers(id){
      return this.users.filter( x => x.getCurrentSituationID() === id).length;
    },

    // Checks if scroll-arrows are visible or not based on the scroll distance
    checkArrowVisibility(){
      let sg = document.getElementsByClassName("sg-items")[0];
      this.arrowLeftVisible = sg.scrollLeft > 50;
      this.arrowRightVisible = sg.offsetWidth + sg.scrollLeft < sg.scrollWidth-50;
    },

    // Plays scroll-animation  
    // direction = -100->left-scroll, 100->right-scroll
    // distance = Scrolldistance (in pixels) 
    // duration = duration of scroll animation (in ms)
    slide(direction,distance=7,duration=300){
      let self = this;
      distance*= direction > 0 ? 1 : -1;
      let startTime = new Date().getTime();
      scrolling();
      function scrolling(){
        let t = new Date().getTime() - startTime;
        if(t < duration){
          t /= duration;
          document.getElementsByClassName("sg-items")[0].scrollBy((1 - Math.sin(t * Math.PI/2)) * distance, 0);
          self.checkArrowVisibility();
          requestAnimationFrame(scrolling);
        }
      }
    },

  },
  
}
</script>